import { Badge, Space, Modal, Row, Col } from 'antd'
import { BaseButton } from 'components/elements/BaseButton'
import { BtnAnch, globalToaster } from 'components/elements/global'
import { FC, useState } from 'react'
import PropertyCard from 'components/shared/PropertyCard'
import { useProListing } from '../provider/ProListingProvider'
import ProSendEmailSMSComponent from './ProSendEmailSMSComponent'

const ProListingActionBlock: FC = () => {
 const { selectedPro, setSelectedPro, type } = useProListing()
 const [showSelectProModal, setShowSelectProModal] = useState(false)

 return (
  <Space>
   {selectedPro.length > 0 && (
    <BaseButton type="link" onClick={() => setShowSelectProModal(true)}>
     Selected properties
     <Badge className="ms-1" count={selectedPro.length ?? 0} />
    </BaseButton>
   )}

   <ProSendEmailSMSComponent from="list" />
   {selectedPro?.length > 0 && (
    <BaseButton type="primary" danger onClick={() => setSelectedPro([])}>
     Clear
    </BaseButton>
   )}

   {showSelectProModal && (
    <Modal
     title="Selected Properties"
     visible={showSelectProModal}
     onCancel={() => setShowSelectProModal(false)}
     footer={false}
     width={1024}
    >
     <Row gutter={[16, 8]}>
      {selectedPro?.map((item, index) => (
       <Col key={index} span={12}>
        <PropertyCard
         item={{
          ...item,
          ...(type === 'preconstruction'
           ? { listing_type: 'preconstruction' }
           : {}),
         }}
         customCloseBtn={
          <BtnAnch
           onClick={() => {
            if (selectedPro?.length === 1) {
             setShowSelectProModal(false)
            }
            if (selectedPro?.find?.((v) => v.ml_num === item.ml_num)) {
             setSelectedPro?.(
              selectedPro.filter((v) => v.ml_num !== item.ml_num),
             )
            }
           }}
           className="pro-selction"
          >
           <i className="fal fa-times" />
          </BtnAnch>
         }
        />
       </Col>
      ))}
     </Row>
    </Modal>
   )}
  </Space>
 )
}

export default ProListingActionBlock
